import React, { useState,useEffect,useRef } from 'react'
import './PdfInvoice.css';
import {InvoicesById} from '../../../../redux/api/invoicesApi/invoicesApi.js'
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from '@chakra-ui/react';
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer
} from '@chakra-ui/react'

export default function InvoicePdf() {
    const pdfRef = useRef(null);
    const location = useLocation();
    const id = location.state?.ROWID || "";
    const [loading, setLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);
    const employeeList = useSelector((state) => state.utils.userList);
    const [employee, setEmployee] = useState([]);
    const [items, setItems] = useState([]);
    
      
   useEffect(() => {
     console.log({ location })
     console.log({ id })
     setLoading(true);
     InvoicesById(id).then((response) => {
       if (response.data.success) {
         setLoading(false);
         setInvoiceData(response.data.invoices[0]);
         const rawItems = response?.data?.invoices[0]?.items || "[]";
         const parsedItems = JSON.parse(rawItems);
         const cleanedItems = parsedItems.map((item) => ({
             itemDetail: item.itemDetail || "",
             annualQty: item.annualQty || "",
             qty: item.qty || "",
             rate: item.rate || "",
             tax: item.tax || "",
             annualContractvalue: item.annualContractvalue || "",
             amount: item.amount || 0,
             servPClean: item.servPClean || "",
             discount: item.discount || "",
             clientData: item.clientData || "",
             rowId: item.rowId || "",
             inventoryData: item.inventoryData || ""
         }));
     setItems(cleanedItems);
    }
  }).catch((error) => {
    setLoading(true);
    console.log({ error });
  });
}, [id]);

useEffect(() => {
  console.log({ invoiceData })
}, [invoiceData])

// Helper function to determine the color based on the value
const getColor = (value) => {
  return value && value !== 'NA' ? '#534f4f' : '#afafaf';
};

useEffect(() => {
  setEmployee(employeeList);
}, [employeeList])
const ownerName = (owner) => {
  const employeeData = employee.filter((item) => item.employees?.ROWID === owner) || 'NA';
  return employeeData[0]?.employees.employeeName
}


    // **Function to calculate total amount (subtotal without tax)**
    const calculateTotalAmount = () => {
        return items.reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0).toFixed(2);
    };

    // **Function to group taxes by percentage**
    const groupTaxesByPercentage = () => {
        const taxGroups = {};

        items.forEach(item => {
            const taxPercentage = item.tax;
            const amount = parseFloat(item.amount) || 0;

            if (taxPercentage && taxPercentage !== 'NA') {
                if (!taxGroups[taxPercentage]) {
                    taxGroups[taxPercentage] = 0;
                }
                taxGroups[taxPercentage] += (amount * (parseFloat(taxPercentage) / 100));
            }
        });

        return Object.keys(taxGroups).map(taxPercentage => ({
            taxPercentage,
            taxAmount: taxGroups[taxPercentage].toFixed(2)
        }));
    };

    // **Function to calculate total including taxes**
    const calculateTotalIncludingTaxes = () => {
        const subtotal = parseFloat(calculateTotalAmount());
        const taxTotal = groupTaxesByPercentage().reduce((acc, taxGroup) => acc + parseFloat(taxGroup.taxAmount), 0);
        return (subtotal + taxTotal).toFixed(2);
    };




    return (
        <>
            {loading && (
             <div className="spinner-overlay">
               <Spinner size="xl" color="pink.500" />
             </div>
               )}
            {/* <button onClick={exportToPdf} className="btn btn-primary">Download PDF</button> */}
            <div ref={pdfRef} className="pdf-container custom-scroll mt-3"  style={{ maxHeight: "72vh",width:"100%", position: "relative", overflowY: "scroll" ,overflowX:'hidden', scrollbarColor: '#A0AEC0 #EDF2F7',
    scrollbarWidth: '10px'  }}>

                <div style={{ fontFamily: 'Open Sans', fontSize: '10pt', color: '#333333', backgroundColor: 'white' }}>
                    <div style={{ padding: '0 0.40in 0 0.55in' }}>
                        <div style={{ display: 'table', width: '100%' }}>
                            <div style={{ float: 'left', width: '50%' }}>
                                <div><img src="https://kappilvermaa.com/solar/wp-content/uploads/2023/09/Frame-141.png" /></div>
                                <b>Numberdar Solar</b>
                                <br />
                                <div>
                                    <span style={{ whiteSpace: 'pre-wrap' }} >
                                        Near Nissan Ford car Showroom, Singhpura
                                        <br />
                                        Khurd, Rohtak, Haryana 124001
                                        <br />
                                        India
                                    </span>
                                </div>
                            </div>
                            <div style={{ float: 'right', width: '50%', textAlign: 'right' }}>
                                <span style={{ fontSize: '28pt', color: '#000000' }}>INVOICE</span>
                                <br />
                                <span style={{ fontSize: '10pt', color: '#817d7d' }}>
                                    <b>{invoiceData?.invoice || 'NA'}</b>
                                </span>
                                <div style={{ clear: 'both', marginTop: '1px' }}>
                                    <span style={{ fontSize: '8pt' }}>
                                        {/* <b>Balance Due</b> */}
                                        {invoiceData?.soDate || 'NA'}
                                    </span>
                                    <br />
                                    {/* <b>%InvoiceBalance%</b> */}
                                    <br />
                                </div>
                            </div>
                        </div>

                        <table
                            style={{  width: '100%',  marginTop: '30px',  tableLayout: 'fixed',  borderSpacing: 0,  borderCollapse: 'collapse', }} >
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%', verticalAlign: 'bottom', wordWrap: 'break-word' }}>
                                        <div>
                                            <label style={{ fontSize: '10pt', color: '#817d7d' }}>
                                                Bill To
                                            </label>
                                            <br />
                                            {ownerName(invoiceData?.accountOwner || 'NA')}
                                            <br />
                                            <span style={{ whiteSpace: 'pre-wrap' }} >
                                            {invoiceData?.salesPerson || 'NA'}
                                                <br />
                                                {invoiceData?.franchiseeAccount || 'NA'}
                                                <br />
                                                {/* %CustomerBCountry% */}{invoiceData?.frequency || 'NA'}

                                            </span>
                                        </div>
                                    </td>

                                    <td style={{ verticalAlign: 'bottom', wordWrap: 'break-word' }} align="right">
                                        <table
                                            style={{tableLayout: 'fixed',wordWrap: 'break-word',borderSpacing: 0,borderCollapse: 'collapse', }} border="0" cellPadding="0" cellSpacing="0" height="96" width="344">
                                            <tbody>
                                                <tr>
                                                    <td style={{ padding: '5px 10px 5px 0px', fontSize: '10pt', textAlign: 'right' }}>
                                                        <span style={{ color: '#817d7d' }}>Invoice Date :</span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{invoiceData?.invoiceDate || 'NA'}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '5px 10px 5px 0px', fontSize: '10pt', textAlign: 'right' }}>
                                                        <span style={{ color: '#817d7d' }}>Terms :</span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span >{invoiceData?.paymentTerms || 'NA'}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '5px 10px 5px 0px', fontSize: '10pt', textAlign: 'right' }}>
                                                        <span style={{ color: '#817d7d' }}>Due Date :</span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span >{invoiceData?.dueDate || 'NA'}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ padding: '5px 10px 5px 0px', fontSize: '10pt', textAlign: 'right' }}>
                                                        <span style={{ color: '#817d7d' }}>P.O.# :</span>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <span>{invoiceData?.orderNumber || 'NA'}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style={{ marginTop: '20px', width: '100%' }}>
                            <span></span>
                        </div>

                        <table
                            style={{width: '100%',marginTop: '20px',tableLayout: 'fixed',borderSpacing: 0,borderCollapse: 'collapse', }} className="pcs-itemtable" border="0" cellPadding="0" cellSpacing="0">
                            <thead>
                                <tr style={{ height: '32px' }}>
                                    <td
                                        style={{fontSize: '10pt',color: '#ffffff',backgroundColor: '#3c3d3a',padding: '5px 10px 5px 10px',wordWrap: 'break-word',}}>
                                        Item &amp; Description
                                    </td>
                                    <td
                                        style={{fontSize: '10pt',color: '#ffffff',backgroundColor: '#3c3d3a',padding: '5px 10px 5px 5px',wordWrap: 'break-word',width: '11%',}}align="right">
                                        Qty
                                    </td>
                                    <td
                                        style={{fontSize: '10pt',color: '#ffffff',backgroundColor: '#3c3d3a',padding: '5px 10px 5px 5px',wordWrap: 'break-word',width: '11%',}}align="right">
                                        Rate
                                    </td>
                                    <td
                                        style={{fontSize: '10pt',color: '#ffffff',backgroundColor: '#3c3d3a',padding: '5px 10px 5px 5px',wordWrap: 'break-word',width: '11%',}}align="right">
                                        Tax
                                    </td>
                                    <td
                                        style={{fontSize: '10pt',color: '#ffffff',backgroundColor: '#3c3d3a',padding: '5px 10px 5px 5px',wordWrap: 'break-word',width: '120px',}}align="right">
                                        Amount
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                        {
                        items.length === 0 || items.every(item => !item.inventoryData && !item.qty && !item.rate && !item.tax && !item.amount) ? (
                            <tr>
                                <td colSpan="5" style={{ textAlign: 'center', fontSize: '9pt', padding: '10px', borderBottom: '1px solid #e3e3e3' }}>
                                    No records
                                </td>
                            </tr>
                        ) : (
                            items.map((item, index) => (
                                <tr key={index}>
                                    <td
                                        style={{
                                            fontSize: '9pt',
                                            borderBottom: '1px solid #e3e3e3',
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            padding: '10px 0px 10px 10px',
                                        }}
                                        valign="top"
                                    >
                                        <span style={{ wordWrap: 'break-word' }}>
                                            {item.inventoryData || 'NA'}
                                        </span>
                                    </td>
                                    <td
                                        style={{
                                            fontSize: '9pt',
                                            borderBottom: '1px solid #e3e3e3',
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            padding: '10px 10px 5px 10px',
                                            textAlign: 'right',
                                            wordWrap: 'break-word',
                                        }}
                                        valign="top"
                                    >
                                        <span>{item.qty || 'NA'}</span>
                                        <br />
                                    </td>
                                    <td
                                        style={{
                                            fontSize: '9pt',
                                            borderBottom: '1px solid #e3e3e3',
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            padding: '10px 10px 5px 10px',
                                            textAlign: 'right',
                                            wordWrap: 'break-word',
                                        }}
                                        valign="top"
                                    >
                                        <span>{item.rate || 'NA'}</span>
                                        <br />
                                    </td>
                                    <td
                                        style={{
                                            fontSize: '9pt',
                                            borderBottom: '1px solid #e3e3e3',
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            padding: '10px 10px 5px 10px',
                                            textAlign: 'right',
                                            wordWrap: 'break-word',
                                        }}
                                        valign="top"
                                    >
                                        {item.tax || 'NA'}
                                        <br />
                                    </td>
                                    <td
                                        style={{
                                            fontSize: '9pt',
                                            borderBottom: '1px solid #e3e3e3',
                                            backgroundColor: '#ffffff',
                                            color: '#000000',
                                            textAlign: 'right',
                                            padding: '10px 10px 10px 5px',
                                            wordWrap: 'break-word',
                                        }}
                                        valign="top"
                                    >
                                        {item.amount || 'NA'}
                                        <br />
                                    </td>
                                </tr>
                            ))
                        )
                    }


                            </tbody>
                            <tbody>
                                <tr>
                                    <td style={{ fontSize: '9pt', borderBottom: '1px solid #e3e3e3', backgroundColor: '#eee', color: '#000000', padding: '10px 0px 10px 10px' }} colspan="5">
                                        {/* <b> %ItemHeaderName%</b> */}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style={{ width: '100%', marginTop: '1px' }}>
                            <div style={{ width: '45%', padding: '3px 10px 3px 3px', fontSize: '9pt', float: 'left' }}>
                                <div style={{ whiteSpace: 'pre-wrap' }}></div>
                            </div>
                            {invoiceData?.items && invoiceData.items.length > 0 && (
                            <div style={{ width: '50%', float: 'right' }}>
                                <table style={{ fontSize: '9pt', color: '#000000', backgroundColor: '#ffffff', borderSpacing: '0', borderCollapse: 'collapse', border: "0", cellspacing: "0", width: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '5px 10px 5px 0', align: "right" }}>Sub Total</td>
                                            <td style={{ width: '120px', padding: '10px 10px 10px 5px', align: "right" }}>{calculateTotalAmount() || 'NA'}
                                                <br />
                                            </td>
                                        </tr>
                                    </tbody>


                                    <tbody>
                                    {groupTaxesByPercentage().map((taxGroup, index) => (
                                        <tr style={{ height: '10px' }}>
                                            <td style={{ padding: '5px 10px 5px 0', align: "right" }}> Tax ({taxGroup.taxPercentage}%):
                                                <br />
                                            </td>
                                            <td style={{ width: '120px', padding: '10px 10px 10px 5px', align: "right" }}>{taxGroup.taxAmount}
                                                <br />
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                    

                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '5px 10px 5px 0', align: "right" }}><b>Total</b>
                                            </td>
                                            <td style={{ width: '120px', padding: '10px 10px 10px 5px', align: "right" }}><b>{calculateTotalIncludingTaxes() || 'NA'}</b>
                                                <br />
                                            </td>
                                        </tr>


                                    </tbody>
                                </table>
                            </div>
                     )}
                            <div style={{ clear: 'both' }}></div>



                            <div style={{ clear: 'both', marginTop: '50px', width: '100%' }}>
                                <label style={{ fontSize: '10pt', color: '#817d7d' }}>
                                    Notes
                                </label>
                                <br />
                                <p style={{ marginTop: '7px', whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '8pt' }}>
                                {invoiceData?.customerNotes || 'NA'}
                                    <br />
                                </p>
                            </div>

                            <div style={{ clear: 'both', marginTop: '30px', width: '100%' }}>
                                <label style={{ fontSize: '10pt', color: '#817d7d' }}>
                                    Terms &amp; Conditions
                                </label>
                                <br />
                                <p style={{ marginTop: '7px', whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '8pt' }}>
                                {invoiceData?.termsConditions || 'NA'}
                                    <br />
                                </p>
                            </div>


                        </div>

                    </div>
                </div>

            </div>
        </>
    );
};
